/*
 * @Author: your name
 * @Date: 2021-12-03 11:14:12
 * @LastEditTime: 2021-12-22 15:05:14
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \insurance-official\src\utils\ele.js
 */
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/element-variables.scss'

import VueBus from 'vue-bus';
import VueClipboards from 'vue-clipboard2'

import {
  Tabs,
  TabPane,
  Backtop,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Pagination
} from 'element-ui'
Vue.use(VueClipboards)
Vue.use(VueBus);
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Backtop)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Pagination)



// WEBPACK FOOTER //
// ./src/utils/ele.js